/* The Candle Studio — step designer, live preview and WhatsApp message. No cart, no checkout. */
(function () {
  'use strict';

  var KEY = 'cst-studio-v1';
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var PIN = /^[1-9]\d{5}$/;
  // Preview geometry per shape: flame base y
  var GEO = { pillar: 96, jar: 128, flower: 166, figure: 94, letter: 98, other: 114 };
  var SVGNS = 'http://www.w3.org/2000/svg';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var desk = window.matchMedia ? matchMedia('(min-width: 900px)') : { matches: false };

  function $(r, s) { return r.querySelector(s); }
  function $$(r, s) { return [].slice.call(r.querySelectorAll(s)); }
  function fill(t, k, v) { return String(t || '').split('[' + k + ']').join(v); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function iso(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  function nice(v) { var p = v.split('-'); return +p[2] + ' ' + MONTHS[+p[1] - 1] + ' ' + p[0]; }
  function load() { try { return JSON.parse(sessionStorage.getItem(KEY)); } catch (e) { return null; } }
  function keep(v) { try { sessionStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }
  function scrollTo(el, block) { try { el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: block || 'start' }); } catch (e) { el.scrollIntoView(); } }
  function focus(el, noScroll) { if (!el) return; try { el.focus({ preventScroll: !!noScroll }); } catch (e) { el.focus(); } }

  function init(root) {
    if (root.__cst) return;
    root.__cst = true;
    var cfg = {};
    try { cfg = JSON.parse($(root, '[data-cst-config]').textContent); } catch (e) {}
    var form = $(root, '[data-cst-form]');
    if (!form) return;

    function q(n) { return $(form, '[name="' + n + '"]'); }
    function checked(n) { return $(form, '[name="' + n + '"]:checked'); }

    var steps = $$(form, '[data-cst-step]');
    var total = steps.length;
    var min = parseInt(form.getAttribute('data-min'), 10) || 1;
    var qty = q('qty'), pin = q('pin'), date = q('date'), notes = q('notes'), other = q('other'), match = q('match');
    var live = $(root, '[data-cst-live]');
    var nextBtn = $(root, '[data-cst-next]'), backBtn = $(root, '[data-cst-back]');
    var progT = $(root, '[data-cst-prog-t]'), progBar = $(root, '[data-cst-prog-bar]'), nextL = $(root, '[data-cst-next-l]');
    var send = $(root, '[data-cst-send]'), reopen = $(root, '[data-cst-reopen]'), sent = $(root, '[data-cst-sent]'), need = $(root, '[data-cst-need]');
    var pv = $(root, '[data-cst-pv]'), grad = $(root, '[data-cst-grad]'), body = $(root, '[data-cst-body]');
    var flame = $(root, '[data-cst-flame]');
    var card = $(root, '[data-cst-preview]'), toggle = $(root, '[data-cst-pv-toggle]');
    var otherBox = $(root, '[data-cst-other]'), count = $(root, '[data-cst-count]'), tc = $(root, '[data-cst-tc]'), mini = $(root, '[data-cst-mini]');

    var tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    var minDate = iso(tomorrow);
    if (date) date.min = minDate;

    var cur = 0, shown = {}, last = {}, sayT = 0;

    function say(msg) {
      clearTimeout(sayT);
      live.textContent = '';
      sayT = setTimeout(function () { live.textContent = msg || ''; }, 60);
    }

    function read() {
      var sh = checked('shape'), sz = checked('size'), oc = checked('occasion');
      var icon = sh ? sh.getAttribute('data-icon') : '';
      function at(el, a) { return el ? el.getAttribute(a) : ''; }
      return {
        shape: sh ? sh.value : '', shapeLabel: at(sh, 'data-label'), icon: icon,
        other: other && icon === 'other' ? other.value.trim() : '',
        colours: $$(form, '[name="colour"]:checked').map(function (el) {
          return { id: el.value, name: at(el, 'data-name'), hex: at(el, 'data-hex') };
        }),
        match: !!(match && match.checked),
        size: sz ? sz.value : '', sizeLabel: at(sz, 'data-label'),
        qty: parseInt(qty.value, 10) || 0,
        occasion: oc ? oc.value : '',
        date: date ? date.value : '',
        pin: pin.value.trim(),
        notes: notes.value.trim()
      };
    }

    function stepNo(i) { return +steps[i].getAttribute('data-cst-step'); }

    function errorFor(n, st) {
      if (n === 1 && !st.shape) return cfg.errShape;
      if (n === 2 && !st.colours.length && !st.match) return cfg.errColour;
      if (n === 3 && st.qty < min) return fill(cfg.errQty, 'min', min);
      if (n === 6) {
        if (!PIN.test(st.pin)) return cfg.errPin;
        if (st.date && st.date < minDate) return cfg.errDate;
      }
      return '';
    }

    function firstBad(st) {
      for (var i = 0; i < total; i++) if (errorFor(stepNo(i), st)) return i;
      return -1;
    }

    function fieldFor(n, st) {
      return n === 1 ? q('shape') : n === 2 ? q('colour') || match : n === 3 ? qty : n === 6 ? (PIN.test(st.pin) ? date : pin) : null;
    }

    function paintErrors(st) {
      steps.forEach(function (fs, i) {
        var n = stepNo(i), msg = errorFor(n, st), box = $(fs, '[data-cst-err]');
        fs.classList.toggle('is-done', !msg && (n === 1 || n === 2 || n === 3 || n === 6));
        if (box) box.textContent = shown[n] ? msg : '';
      });
      var pinBad = !!shown[6] && !PIN.test(st.pin);
      qty.setAttribute('aria-invalid', shown[3] && st.qty < min ? 'true' : 'false');
      pin.setAttribute('aria-invalid', pinBad ? 'true' : 'false');
      if (date) date.setAttribute('aria-invalid', shown[6] && !pinBad && st.date && st.date < minDate ? 'true' : 'false');
    }

    function paintPreview(st) {
      var shape = GEO[st.icon] ? st.icon : 'pillar', g = GEO[shape];
      pv.setAttribute('data-shape', shape);
      pv.classList.toggle('is-empty', !st.shape);

      var cols = st.colours.map(function (c) { return c.hex; });
      if (!cols.length) cols = [st.match ? '#efe3cf' : '#f4ede0'];
      var n = cols.length;
      while (grad.firstChild) grad.removeChild(grad.firstChild);
      cols.forEach(function (hex, i) {
        var a = i / n + (i ? 0.04 : 0), b = (i + 1) / n - (i < n - 1 ? 0.04 : 0);
        [a, b].forEach(function (o) {
          var s = document.createElementNS(SVGNS, 'stop');
          s.setAttribute('offset', o.toFixed(3));
          s.setAttribute('stop-color', hex);
          grad.appendChild(s);
        });
      });

      var sc = { small: 0.84, medium: 0.92, large: 1 }[st.size] || 0.92;
      body.setAttribute('transform', 'translate(100 240) scale(' + sc + ') translate(-100 -240)');
      flame.setAttribute('transform', 'translate(100 ' + g + ')');
    }

    function lowerFirst(t) { t = String(t || ''); return t.charAt(0).toLowerCase() + t.slice(1); }

    function colourText(st, forMsg) {
      var c = st.colours.map(function (x) { return x.name; }).join(', ');
      if (st.match) c = c ? c + (forMsg ? ' (' + lowerFirst(cfg.match) + ')' : ' + ' + lowerFirst(cfg.match)) : cfg.match;
      return c;
    }

    function shapeText(st) { return st.shape ? st.shapeLabel + (st.other ? ' – ' + st.other : '') : ''; }

    function paintSummary(st) {
      var map = {
        shape: shapeText(st),
        colours: colourText(st, false),
        size: st.sizeLabel,
        qty: st.qty ? String(st.qty) : '',
        occasion: st.occasion,
        date: st.date && st.date >= minDate ? nice(st.date) : '',
        pin: PIN.test(st.pin) ? st.pin : ''
      };
      $$(root, '[data-cst-sum]').forEach(function (dd) { dd.textContent = map[dd.getAttribute('data-cst-sum')] || '—'; });
      if (!mini) return;
      var m = [];
      if (st.shape) m.push(st.shapeLabel);
      if (st.colours.length === 1) m.push(st.colours[0].name);
      else if (st.colours.length > 1) m.push(fill(cfg.colourN, 'n', st.colours.length));
      if (st.qty) m.push(fill(cfg.qtyN, 'n', st.qty));
      mini.textContent = st.shape ? m.join(' · ') : cfg.miniEmpty;
    }

    function message(st) {
      var b = '• ', L = [cfg.intro], c = colourText(st, true), sq = [], dp = [];
      if (st.shape) L.push(b + cfg.mShape + ': ' + shapeText(st));
      if (c) L.push(b + cfg.mColours + ': ' + c);
      if (st.sizeLabel) sq.push(cfg.mSize + ': ' + st.sizeLabel);
      if (st.qty) sq.push(cfg.mQty + ': ' + st.qty);
      if (sq.length) L.push(b + sq.join(' · '));
      if (st.occasion) L.push(b + cfg.mOccasion + ': ' + st.occasion);
      if (st.date && st.date >= minDate) dp.push(cfg.mDate + ': ' + nice(st.date));
      if (PIN.test(st.pin)) dp.push(cfg.mPin + ': ' + st.pin);
      if (dp.length) L.push(b + dp.join(' · '));
      if (st.notes) L.push(b + cfg.mNotes + ': ' + st.notes.replace(/\s+/g, ' '));
      if (cfg.outro) L.push(cfg.outro);
      return L.join('\n');
    }

    function save(st) {
      keep({
        shape: st.shape, other: other ? other.value : '', colours: st.colours.map(function (c) { return c.id; }),
        match: st.match, size: st.size, qty: qty.value, occasion: st.occasion,
        date: st.date, pin: pin.value, notes: notes.value, step: cur
      });
    }

    function update() {
      var st = read(), nCol = st.colours.length;
      $$(form, '[name="colour"]').forEach(function (el) { el.disabled = !el.checked && nCol >= 3; });
      if (count) count.textContent = fill(cfg.count, 'n', nCol);
      if (otherBox) otherBox.hidden = st.icon !== 'other';
      if (tc) tc.textContent = notes.value.length;
      paintErrors(st);
      paintPreview(st);
      paintSummary(st);

      var url = 'https://wa.me/' + cfg.wa + '?text=' + encodeURIComponent(message(st));
      send.href = url;
      if (reopen) reopen.href = url;
      var bad = firstBad(st);
      send.setAttribute('aria-disabled', bad > -1 ? 'true' : 'false');
      if (need) {
        var list = [];
        if (!st.shape) list.push(cfg.needShape);
        if (!nCol && !st.match) list.push(cfg.needColour);
        if (st.qty < min) list.push(cfg.needQty);
        if (!PIN.test(st.pin)) list.push(cfg.needPin);
        need.textContent = bad < 0 ? cfg.ready : list.length ? fill(cfg.need, 'list', list.join(', ')) : errorFor(stepNo(bad), st);
      }
      nextBtn.setAttribute('aria-disabled', errorFor(stepNo(cur), st) ? 'true' : 'false');
      save(st);
      return st;
    }

    function go(i, user) {
      cur = Math.max(0, Math.min(total - 1, i));
      steps.forEach(function (fs, k) { fs.classList.toggle('is-active', k === cur); });
      var label = fill(fill(cfg.step, 'n', cur + 1), 'total', total);
      progT.textContent = label;
      progBar.style.setProperty('--p', ((cur + 1) / total).toFixed(4));
      backBtn.hidden = cur === 0;
      nextL.textContent = cur === total - 1 ? cfg.review : cfg.next;
      update();
      if (user && !desk.matches) {
        var t = $(steps[cur], '.cst-step__t');
        say(label + ': ' + (t ? t.textContent : ''));
        var panel = $(root, '.cst-panel');
        if (panel.getBoundingClientRect().top < 0) scrollTo(panel);
        focus(steps[cur], true);
      }
    }

    // Show the first missing required detail. Returns true when something is missing.
    function showBad(st) {
      var i = firstBad(st);
      if (i < 0) return false;
      var n = stepNo(i);
      shown[n] = true;
      if (!desk.matches && i !== cur) go(i, false);
      paintErrors(st);
      say(errorFor(n, st));
      var fl = fieldFor(n, st);
      if (fl) {
        if (desk.matches) scrollTo(steps[i], 'center');
        focus(fl, desk.matches);
      }
      return true;
    }

    function restore() {
      var d = load();
      if (!d) return;
      function pick(n, v) {
        if (!v) return;
        $$(form, '[name="' + n + '"]').forEach(function (el) {
          if (el.value === v) { el.checked = true; last[n] = el; }
        });
      }
      pick('shape', d.shape);
      pick('size', d.size);
      pick('occasion', d.occasion);
      var ids = (d.colours || []).slice(0, 3);
      $$(form, '[name="colour"]').forEach(function (el) { el.checked = ids.indexOf(el.value) > -1; });
      if (match) match.checked = !!d.match;
      if (other) other.value = String(d.other || '').slice(0, 60);
      qty.value = String(d.qty || min).replace(/\D/g, '').slice(0, 3) || min;
      if (date && d.date && d.date >= minDate) date.value = d.date;
      pin.value = String(d.pin || '').replace(/\D/g, '').slice(0, 6);
      notes.value = String(d.notes || '').slice(0, 300);
      cur = Math.max(0, Math.min(total - 1, d.step | 0));
    }

    /* events */
    form.addEventListener('input', function (e) {
      var t = e.target, v;
      if ((t === qty || t === pin) && (v = t.value.replace(/\D/g, '')) !== t.value) t.value = v;
      update();
    });
    form.addEventListener('change', update);
    form.addEventListener('submit', function (e) { e.preventDefault(); });

    // Optional single-choice groups: a second click clears the choice
    form.addEventListener('click', function (e) {
      var el = e.target;
      if (!el.hasAttribute || !el.hasAttribute('data-cst-toggle')) return;
      if (last[el.name] === el) { el.checked = false; last[el.name] = null; update(); }
      else last[el.name] = el;
    });

    $$(root, '[data-cst-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = (parseInt(qty.value, 10) || 0) + (+b.getAttribute('data-cst-qty'));
        qty.value = Math.max(min, Math.min(999, v));
        update();
      });
    });

    nextBtn.addEventListener('click', function () {
      var st = read(), n = stepNo(cur), msg = errorFor(n, st);
      if (msg) {
        shown[n] = true;
        paintErrors(st);
        say(msg);
        focus(fieldFor(n, st));
        return;
      }
      if (cur < total - 1) { go(cur + 1, true); return; }
      if (!showBad(st)) { scrollTo(send, 'center'); focus(send, true); }
    });

    backBtn.addEventListener('click', function () { go(cur - 1, true); });

    send.addEventListener('click', function (e) {
      if (showBad(update())) { e.preventDefault(); return; }
      setTimeout(function () {
        sent.hidden = false;
        focus(sent, true);
      }, 400);
    });

    if (toggle) {
      toggle.addEventListener('click', function () {
        var open = !card.classList.contains('is-open');
        card.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        var more = $(toggle, '.cst-preview__more');
        if (more) more.textContent = open ? cfg.hide : cfg.show;
      });
    }

    var start = $(root, '[data-cst-go]');
    if (start) {
      start.addEventListener('click', function (e) {
        var d = $(root, '.cst-designer');
        if (!d) return;
        e.preventDefault();
        scrollTo(d);
        focus($(d, '.cst-h2'), true);
      });
    }

    /* boot */
    restore();
    var b0 = firstBad(read());
    if (b0 > -1 && b0 < cur) cur = b0;
    go(cur, false);

    /* hero flame pause off-screen + fade-up reveals */
    var rv = $$(root, '[data-cst-reveal]');
    if (!('IntersectionObserver' in window) || reduce) {
      rv.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var hero = $(root, '[data-cst-hero]');
    if (hero) {
      new IntersectionObserver(function (en) { hero.classList.toggle('is-off', !en[0].isIntersecting); }).observe(hero);
    }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) {
        if (!x.isIntersecting) return;
        x.target.classList.add('is-in');
        io.unobserve(x.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    rv.forEach(function (el) { io.observe(el); });
  }

  function boot() { $$(document, '[data-cst]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
